import { Controller, useFormContext } from "react-hook-form";
import { DatePicker, type DatePickerProps } from "@heroui/date-picker";
import { parseDate, getLocalTimeZone } from "@internationalized/date";
import dayjs from "dayjs";

function DateInput({
    name,
    hideErrorMessage,
    ...props
}: {
    name: string;
    hideErrorMessage?: boolean;
} & DatePickerProps) {
    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            render={({
                field: { onChange, onBlur, value },
                fieldState: { error, invalid },
            }) => {
                return (
                    <DatePicker
                        {...props}
                        onChange={(e) => {
                            onChange(e?.toDate(getLocalTimeZone()));
                        }}
                        onBlur={onBlur}
                        color={invalid ? "danger" : props.color}
                        value={
                            value
                                ? parseDate(dayjs(value).format("YYYY-MM-DD"))
                                : undefined
                        }
                        variant="flat"
                        errorMessage={
                            hideErrorMessage ? undefined : error?.message
                        }
                        isInvalid={invalid}
                    />
                );
            }}
        />
    );
}

export default DateInput;
